module.exports = __webpack_public_path__ + "static/circled-info.639fc1fe.svg";